export const NOTIFICATION_TRANSITION_DURATION = 400 // should have the same value as `&.show transition` in `_Notification`
export const NOTIFICATION_SHOW_DURATION = 5000
export const NOTIFICATION_LONG_SHOW_DURATION = 8000
